/* eslint-disable sonarjs/no-identical-functions */
import { useState } from "react";
import styled from "styled-components";

import { Colors, MediaQueries, Spacing } from "@paclife/plds.tokens";
import { Button } from "@paclife/plds.button";

import Typography from "common/Typography/Typography";
import BaseModal from "common/Modal/BaseModal";
import Checkbox from "common/Checkbox/Checkbox";

const acknowledge =
    "I understand unauthorized access or the improper use of the information and/or applications may constitute a violation of privacy or data security laws. I acknowledge that I am inviting my team member/staff to register for access to my clients’ accounts through Contract Management. I agree to oversee their actions and will indemnify and hold harmless Pacific Life against all claims, actions, costs, and liabilities arising out of or relating to their execution of instructions provided in Contract Management. I will promptly remove access to any team member/staff that should no longer need to have access.";

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Title = styled(Typography)`
    color: ${Colors.primary};
    margin: ${Spacing[16]} 0 ${Spacing[24]};
    // tablet and mobile
    @media (max-width: ${MediaQueries.lg}) {
        margin: ${Spacing[8]} 0;
    }
`;

const SubTitle = styled(Typography)`
    margin-bottom: ${Spacing[16]};
`;

const CancelButton = styled(Button)`
    width: 108px;
`;
const ConfirmButton = styled(Button)`
    width: 108px;
`;

const ConfirmInviteModal = ({ closeModal, name }) => {
    const [checked, setChecked] = useState(false);
    const [disabledInvite, disableInvite] = useState(true);

    const handleChange = (e) => {
        setChecked(e.target.checked);
        if (e.target.checked) {
            disableInvite(false);
        } else {
            disableInvite(true);
        }
    };

    const invite = async () => {};

    const handleCancel = () => {
        setChecked(false);
        closeModal();
    };

    return (
        <BaseModal
            size="xlarge"
            secondaryButton={
                <CancelButton
                    variant="secondaryNeutral"
                    onClick={handleCancel}
                    data-track="analytics"
                    data-bname="confirm-invite-modal-cancel"
                >
                    Cancel
                </CancelButton>
            }
            primaryButton={
                <ConfirmButton
                    onClick={invite}
                    disabled={disabledInvite}
                    data-track="analytics"
                    data-bname="confirm-invite-modal-invite"
                >
                    Invite
                </ConfirmButton>
            }
            closeModal={closeModal}
        >
            <Content>
                <Title variant="h2" display="block" align="center">
                    Found An Existing Team Member
                </Title>
                <SubTitle variant="body" align="center" bold>
                    {name} is associated to another Financial Professional. By
                    checking the box below, you agree to invite this team member
                    to also be a part of your team.
                </SubTitle>
                <Checkbox
                    id="acknowledge-confirm"
                    label={acknowledge}
                    name="acknowledge-confirm"
                    checked={checked}
                    onChange={handleChange}
                />
            </Content>
        </BaseModal>
    );
};

export default ConfirmInviteModal;
